import { DivisionTree, SurveyType } from '@zencity/survey-types';
import { createAxiosInstance, generateVaultApiUrl } from 'utils/Api';
import { useQuery, UseQueryResult } from 'react-query';

const apiUrl = generateVaultApiUrl('/api/v2/divisions/');
const axiosInstance = createAxiosInstance(apiUrl);

export const fetchDivisionsTree = async (surveyType?: SurveyType, zcClientId?: string): Promise<DivisionTree[]> => {
  const isRequestPossible = zcClientId && surveyType;
  if (!isRequestPossible) {
    return Promise.resolve([]);
  }

  const response = await axiosInstance.get<DivisionTree[]>(`tree/`, {
    params: {
      zc_client_id: zcClientId,
      survey_type: surveyType,
    },
  });
  return response.data;
};

export const useQueryToFetchDivisionsTree = (
  surveyType?: SurveyType,
  zcClientId?: string,
): UseQueryResult<DivisionTree[]> =>
  useQuery(['fetchDivisionsTree', surveyType, zcClientId], () => fetchDivisionsTree(surveyType, zcClientId), {
    refetchOnWindowFocus: false,
  });
